import ChunkInfiniteScroll from "../../components/InfiniteScroll/ChunkInfiniteScroll";
import Survey from "../../components/Surveys/Survey";
import {useTranslation} from "react-i18next";
import AdvertiseBlock from "../../components/AdvertiseBlock";
import useMetaTags from "react-metatags-hook";
import {useEffect, useState} from "react";
import trackPageView from "../../services/trackPageView";

export default function FinishedList({surveys, categories}) {
    const chunkSize = 16;
    const { t } = useTranslation();
    useMetaTags({
        title: t('surveys.titleFinished'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });
    useEffect(() => {
        trackPageView(t('surveys.titleFinished'));
    })
    const [currentPage, setCurrentPage] = useState(1);
    const incrementPage = () => setCurrentPage(currentPage + 1);

    return (
        <>
            <AdvertiseBlock unitId="surveys2" blockLocation="content" />
            <div className="survey-items-desktop">
                <div className="survey-items-grid">
                    <ChunkInfiniteScroll
                        Component={Survey}
                        items={surveys}
                        allCategories={categories}
                        callback={incrementPage}
                        cancel={surveys.length < currentPage * chunkSize}
                    />
                </div>
                { !surveys.length &&
                <div className="js-surveys-no-found">
                    <h2 className="not-found" dangerouslySetInnerHTML={{__html: t('surveys.notFound')}}>
                    </h2>
                </div>
                }
            </div>
        </>
    );
}
